module.exports = __webpack_public_path__ + "static/img/404-01.cb62aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/404-01.png
// module id = 2979
// module chunks = 1